<template>
    <v-container fluid>
        <v-card class="pl-6 pr-6 pt-6 pb-6">
            <v-row>
                <v-col cols="6" md="6" >
                    <v-card-title class="text-h5">Add Keyword</v-card-title>
                </v-col>
            </v-row>
            <v-card-text>
                <v-row >
                    <v-col cols="12" md="6">
                        <h3><span class="red--text">* </span>Work Type</h3>
                        <v-autocomplete
                            v-model="doctype"
                            :items="doctype_list"
                            item-text="documenttype_code"
                            item-value="documenttype_id"
                            outlined
                            dense
                            @change="onSelectDoctype()"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row class="mt-n7" v-if="disableNotice">
                    <v-col cols="12" md="6">
                        <h3><span class="red--text">* </span>Notice Type</h3>
                        <v-autocomplete
                            v-model="notice"
                            :items="notice_list"
                            item-text="notice_code"
                            item-value="notice_id"
                            outlined
                            notice_list
                            dense
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row class="mt-n7">
                    <v-col cols="12" md="8">
                        <h3>Keyword</h3>
                        <v-text-field
                            v-model="keyword"
                            outlined
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-row align="center">
                    <v-spacer></v-spacer>
                    <v-btn
                        depressed
                        width="100"
                        class="mr-3 buttonblue"
                        @click="saveaddItem()"
                    >
                        Save
                    </v-btn>
                    <v-btn depressed outlined width="100" @click="$router.back()">
                        Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-row>
            </v-card-actions>
        </v-card>
        <SuccessDialog
            :status="dialogAdd"
            :text_color="text_color"
            :title="title"
            :message="message"
        />
    
        <SuccessDialogPush
            :status="dialogAdd"
            :text_color="text_color"
            :title="title"
            :message="message"
            :link="link"
        />
        </v-container>
    </template>
    
<script>
    import api from "@/services/api";
    import { server } from "@/services/constants";
    import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
    import SuccessDialog from "@/components/cards/SuccessDialog";
    
    export default {
      name: "MappingList",
      async mounted() {
        this.$showLoader();
    
        // ----------------- Check Authorize ---------------------------
        this.userId = localStorage.getItem(server.USER_ID);
        let yourUrlString = window.location;
        // alert(yourUrlString);
    
        let parser = document.createElement("a");
        parser.href = yourUrlString;
    
        this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
        // alert("authorize_id:" + this.authorize_id);
        if (this.authorize_id == null || this.authorize_id == 0) {
          // this.$router.push("/login");
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Authorize Failed",
            "Please Logout And Login Again",
            "text-h5 red--text text-center"
          );
          this.$router.back();
        }
    
        const router_path = parser.pathname.replace("/", "");
        await this.loadDoctype()
        await this.loadNotice()
        this.$hideLoader();
      },
      components: { SuccessDialog, SuccessDialogPush },
      data() {
        return {
          userId: 0,
          authorize: [],
          doctype_list: [],
          notice_list: [],
          notice: 0,
          gropType: 0,
          keyword: "",
          disableNotice: false,
          authorize_view: false,
          authorize_add: false,
          authorize_edit: false,
          authorize_del: false,
          authorize_id: 0,
          load_bg: false,
          dialogAddKeyword: false,
          dialogAdd: false,
          dialogAddData: false,
          dialogDelete: false,
          isShowPassword: false,
          fullPage: true,
          search: "",
          doctype: 0,
          mDataArray: [],
          text_color: "text-h5 green--text text-center",
          title: "green",
          message: "green",
          link: "",
          search_ct: "",
          itemdata: {
            contact_type: 0,
            contact_name: "",
            contact_person: "",
            position: "",
            email: "",
            address: "",
            city: "",
            country: "",
            telephone: "",
            fax: "",
            status: "A",
          },
          edititemdata: {
            contact_type: 0,
            contact_name: "",
            contact_person: "",
            position: "",
            email: "",
            address: "",
            city: "",
            country: "",
            telephone: "",
            fax: "",
          },
          contactid_del: 0,
          oparation: "",
          headers: [
            {
              text: "Work Type",
              value: "",
              class: "bg-colorth",
              divider: true,
              // width: "8%",
            },
            {
              text: "Notice Type",
              value: "contact_name",
              class: "bg-colorth",
              divider: true,
              // width: "10%",
            },
            
            {
              text: "",
              value: "actions",
              class: "bg-colorth",
              divider: true,
              width: "140px",
            },
          ],
        };
      },
      methods: {
        async loadDoctype() {
            const res_doctype = await api.getdocumenttypeAll()
            this.doctype_list =  res_doctype.data;
        },
        async loadNotice() {
            const res_notice = await api.getnotice_code()
            this.notice_list =  res_notice.data;
        },
        async onSelectDoctype() {
            this.doctype_list.forEach((item)=>{
                if(item.documenttype_id == this.doctype){
                    this.gropType = item.objectgroup_id;
                }
            })
            if(this.gropType == 1 || this.gropType == "1"){
                this.disableNotice = true;
            }else{
                this.disableNotice = false;
                this.notice = 0;
            }
        },
        async saveaddItem(){
            if (this.doctype == 0) {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Work Type Data",
                    "text-h5 red--text text-center"
                );
                return;
            }
            if(this.disableNotice == true){
                
                if (this.notice == 0) {
                    this.$store.state.global_dialog = true;
                    this.setupAlertDialog(
                        true,
                        "Failed",
                        "Please enter Notice Type Data",
                        "text-h5 red--text text-center"
                    );
                    return;
                }
            }
            if (this.keyword == "") {
                this.$store.state.global_dialog = true;
                this.setupAlertDialog(
                    true,
                    "Failed",
                    "Please enter Keyword Data",
                    "text-h5 red--text text-center"
                );
                return;
            }
            const dataitem = {
                doctype_id: this.doctype,
                notice_type: this.notice,
                objectgroup_id: this.gropType,
                kw: this.keyword,
            }
            this.$showLoader()
            const res_add =  await api.createOCRKW(dataitem)
            // alert(res_add.status)
            
            if (res_add.status == 200 || res_add.status == 201) {
                this.$hideLoader();
                this.$store.state.global_push_dialog = true;
                this.setupAlertDialogPush(
                    true,
                    "save data",
                    "save data success",
                    "text-h5 green--text text-center",
                    "/mapping-keyword"
                    );
                return;
            }
            
        },
        setupAlertDialogPush(status, title, message, text_color, link) {
          this.title = title;
          this.message = message;
          this.dialogAdd = status;
          this.text_color = text_color;
          this.link = link;
        },
        setupAlertDialog(status, title, message, text_color) {
          this.title = title;
          this.message = message;
          this.dialogAdd = status;
          this.text_color = text_color;
        },
      },
      beforeCreate() {
        this.$store.state.navMenu = true;
      },
    };
</script>
    
<style scoped>
    .widthbtncal {
        width: 100%;
    }
    .widthbtnimagefile {
        width: 40%;
    }
    .widthsizesearch {
        width: 70%;
    }
    .v-btn:not(.v-btn--round).v-size--default.buttongold {
        background-color: #464231;
        color: white;
    }

    .v-btn:not(.v-btn--round).v-size--default.buttonblue {
        background-color: #1d2442;
        color: white;
    }
    .btnuploadfile {
        border: 2px solid;
    }
    .v-btn:not(.v-btn--round).v-size--default.buttonred {
        width: 100%;
        background-color: #9e3b1b;
        color: white;
    }
    h3 {
        font-size: 1.17em;
    }
    h4 {
        font-size: 0.875rem;
    }
</style>
    